// ---------------------------------------------------------------------------
// Inject all styling IMMEDIATELY on script load — NOT inside the
// "algolia.hooks.initialize" callback. That event fires a moment after the
// first paint, so styling it there caused a brief flash of the default Algolia
// layout before our styles took over. Running it at the top level applies the
// CSS as early as the script executes, before Algolia's results render.
// (3 cols desktop / 2 cols mobile — gap-x: 32px, gap-y: 64px)
// ---------------------------------------------------------------------------
(function injectAlgoliaCustomStyles() {
  const style = document.createElement("style");
  style.textContent = `
    .ais-Hits-list {
      display: grid !important;
      grid-template-columns: repeat(2, 1fr) !important;
      column-gap: 32px !important;
      row-gap: 64px !important;
      list-style: none;
      padding: 0;
      margin: 0;
    }
    @media (min-width: 640px) {
      .ais-Hits-list {
        grid-template-columns: repeat(3, 1fr) !important;
      }
    }
    .ais-Hits-item {
      width: auto !important;
      min-width: 0;
      display: flex;
    }
    .ais-Hits-item product-card {
      width: 100%;
    }
    /* The collection grid sets a 15px base font-size on its wrapper, but the
       Algolia results page injects an aggressive reset
       (.ais-page p, div, span, … { font-size: medium } == 16px) that overrides
       the theme's card sizing element-by-element. These selectors are specific
       enough to beat that reset and restore the native collection-card sizes. */
    .ais-Hits-item product-card.card--product {
      font-size: 15px;
    }
    .ais-page .ais-Hits-item product-card .card__vendor {
      font-size: 13px;
    }
    .ais-page .ais-Hits-item product-card .card__title,
    .ais-page .ais-Hits-item product-card .price,
    .ais-page .ais-Hits-item product-card .price__current,
    .ais-page .ais-Hits-item product-card .price__compare {
      font-size: 15px;
    }
    .ais-page .ais-Hits-item product-card .product-card-size-box,
    .ais-page .ais-Hits-item product-card .product-card-size-box *,
    .ais-page .ais-Hits-item product-card .sizes-more {
      font-size: 11px;
    }
    /* The theme's .product-label--sale only defines colors; it has no position
       offsets, so position:absolute left the discount badge at its static
       spot (just below the image) overlapping the vendor/title. Pin it to the
       image's top-left corner and reset the inherited 16px text size. */
    .ais-page .ais-Hits-item product-card .card__media {
      position: relative;
    }
    .ais-page .ais-Hits-item product-card .card__media .product-label--sale {
      position: absolute;
      top: 10px;
      left: 0;
      right: auto;
      bottom: auto;
      z-index: 3;
      padding: 5px 11px;
      font-size: 13px;
      line-height: 1.4;
    }
    .ais-page .ais-Hits-item product-card .card__media .product-label--sale span {
      font-size: 13px;
    }
    /* Grey image backdrop + contain, so wide bike images aren't cropped
       (matches the collection page, where .media has a #f5f5f5 background
       and the image uses object-fit: contain). */
    .ais-page .ais-Hits-item product-card .card__media .media {
      background-color: #f5f5f5;
    }
    .ais-page .ais-Hits-item product-card .card__main-image {
      object-fit: contain;
      /* Same trick the collection page uses (.image-blend img): multiply the
         image against the grey .media background so white product backgrounds
         blend away instead of showing as a white box. */
      mix-blend-mode: multiply;
    }
    /* Remove the browser-default <dd> indent (margin-left: 40px) that pushed
       the prices to the right. */
    .ais-page .ais-Hits-item product-card .price__list dd {
      margin: 0;
    }
    /* Breathing room: space under the image, and between brand and title. */
    .ais-page .ais-Hits-item product-card .card__info-container {
      padding-top: 14px;
    }
    .ais-page .ais-Hits-item product-card .card__vendor {
      margin-bottom: 5px;
    }
    /* Make the red sale price the prominent one and mute the compare price. */
    .ais-page .ais-Hits-item product-card .price__current--sale {
      font-size: 17px;
      font-weight: 700;
    }
    .ais-page .ais-Hits-item product-card .price__compare {
      font-size: 13px;
      color: #767676;
    }
    /* Tag badge (.badge-container, e.g. "Bike Mailorder Tipp"): the .ais-page
       font reset blew it up to 16px and stripped its padding, and the main/tip
       text ran together. Restore padding, a gap before the tip, sensible size. */
    .ais-page .ais-Hits-item .badge-container {
      padding: 4px 9px !important;
    }
    .ais-page .ais-Hits-item .badge-main,
    .ais-page .ais-Hits-item .badge-tip {
      font-size: 13px !important;
    }
    .ais-page .ais-Hits-item .badge-tip {
      margin-left: 5px;
    }
    /* Stack the (wide) black tag badge ABOVE the red sale badge so it sits at
       the very top and doesn't cover the middle of the product image. The sale
       badge only drops down when a tag badge is actually present (:has). */
    .ais-page .ais-Hits-item .card__media .product-label-container {
      margin-top: 10px !important;
    }
    .ais-page .ais-Hits-item .card__media:has(.product-label-container) .product-label--sale {
      top: 40px !important;
    }
    .ais-page .ais-facets .ais-facet--header {
       text-transform:none;
        background: #fff;
        color: #000;
       font-weight: 600;
    }
       .ais-facets .ais-facet-dropdown-wrapper {
        border-top: 1px solid #e2e2e2;
        padding-top: 20px;
       }
        .ais-results-size-lg .ais-page .ais-results-as-block .ais-hit.ais-product {
        width:100%;}

    /* ---------------------------------------------------------------------
       Results page: facet (filter) hover — drop the left bar, just turn the
       text full black instead. (The default added a 4px left border + shift.)
       --------------------------------------------------------------------- */
    .ais-page .ais-RefinementList-item--selected,
    .ais-page .ais-facet--item:not(.ais-HierarchicalMenu-item--parent):hover {
      border-left: 0 !important;
      margin-left: 0 !important;
      padding-left: 0 !important;
    }
    .ais-page .ais-facet--item:hover .ais-facet--count,
    .ais-page .ais-RefinementList-item--selected .ais-facet--count {
      right: 0 !important;
    }
    .ais-page .ais-facet a:hover,
    .ais-page .ais-facet--item:hover,
    .ais-page .ais-facet--item:hover a {
      color: #000 !important;
    }
    .ais-page .ais-RefinementList-item--selected,
    .ais-page .ais-RefinementList-item--selected a {
      color: #000 !important;
      font-weight: 600 !important;
    }

    /* Headroom above the slider so the numbers (now placed above the track)
       don't collide with the "Price" heading. */
    .ais-page .rheostat {
      margin-top: 40px !important;
    }
    /* Price slider tick labels were wrapping vertically (each digit on its own
       line) because the marker is only a few px wide — keep them on one line,
       and place them ABOVE the track/handles, raised enough that the draggable
       handle doesn't cover them. */
    .ais-page .rheostat-value {
      white-space: nowrap !important;
      top: auto !important;
      bottom: 24px !important;
    }
    /* Append € to the slider tick labels. */
    .ais-page .rheostat-value::after {
      content: " €";
    }
    /* The value bubble that pops up while dragging a handle: keep it on one
       line, place it ABOVE the handle, centre it, and append € too. */
    .ais-page .rheostat-tooltip {
      white-space: nowrap !important;
      left: 50% !important;
      top: auto !important;
      bottom: calc(100% + 6px) !important;
      transform: translateX(-50%) !important;
    }
    .ais-page .rheostat-tooltip::after {
      content: " €";
    }

    /* Remove the add-to-cart / quick-add overlay that appeared on card hover. */
    .ais-Hits-item product-card .card__quick-add {
      display: none !important;
    }

    /* ---------------------------------------------------------------------
       Pagination: top margin, centered layout, ‹ › arrow prev/next, no boxes,
       underlined current page. (Theme default boxed every item, hid disabled
       arrows entirely, and showed « » first/last glyphs too.)
       --------------------------------------------------------------------- */
    .ais-pagination-container {
      margin-top: 48px !important;
      padding-bottom: 16px;
    }
    .ais-page .ais-Pagination-list {
      display: flex !important;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      gap: 4px;
      margin: 0;
      padding: 0;
    }
    .ais-page .ais-Pagination-item {
      border: 0 !important;
      border-radius: 0 !important;
      margin: 0 !important;
    }
    /* hide the « first / » last double-arrows — keep just the ‹ › prev/next */
    .ais-page .ais-Pagination-item--firstPage,
    .ais-page .ais-Pagination-item--lastPage {
      display: none !important;
    }
    /* keep prev/next visible (greyed) even when disabled on the first/last page */
    .ais-page .ais-Pagination-item--previousPage.ais-Pagination-item--disabled,
    .ais-page .ais-Pagination-item--nextPage.ais-Pagination-item--disabled {
      visibility: visible !important;
    }
    .ais-page .ais-Pagination-link {
      display: inline-block;
      padding: 8px 12px;
      color: #000;
      text-align: center;
    }
    .ais-page .ais-Pagination-item--page .ais-Pagination-link {
      min-width: 40px;
    }
    .ais-page .ais-Pagination-item--selected .ais-Pagination-link {
      font-weight: 700;
      text-decoration: underline;
      text-underline-offset: 4px;
    }
    /* Prev/next show just the ‹ › arrow glyphs (no "Vorherige"/"Nächste"
       labels) so the row stays compact and never wraps on mobile. */
    .ais-page .ais-Pagination-item--previousPage {
      margin-right: 8px !important;
    }
    .ais-page .ais-Pagination-item--nextPage {
      margin-left: 8px !important;
    }
    .ais-page .ais-Pagination-item--disabled .ais-Pagination-link {
      color: #9a9a9a;
      cursor: default;
    }

    /* ---------------------------------------------------------------------
       Results page on mobile (<768px): the page has a 53px left/right margin
       that wastes most of a phone's width, and the tag badge is oversized for
       the narrow 2-up cards. Tighten the edges and shrink the badge.
       --------------------------------------------------------------------- */
    @media (max-width: 767px) {
      .ais-page {
        margin-left: 0 !important;
        margin-right: 0 !important;
        padding-left: 4px !important;
        padding-right: 4px !important;
      }
      .ais-Hits-list {
        column-gap: 12px !important;
        row-gap: 28px !important;
      }
      .ais-page .ais-Hits-item .badge-container {
        padding: 3px 7px !important;
      }
      .ais-page .ais-Hits-item .badge-main,
      .ais-page .ais-Hits-item .badge-tip {
        font-size: 10px !important;
      }
      /* tighter badge stacking for the smaller mobile badges */
      .ais-page .ais-Hits-item .card__media .product-label-container {
        margin-top: 8px !important;
      }
      .ais-page .ais-Hits-item .card__media:has(.product-label-container) .product-label--sale {
        top: 32px !important;
      }
    }

    /* ---------------------------------------------------------------------
       Constrain the header search bar to a centered width. The theme's
       .header__search has flex-grow and grows to fill the header (~975px);
       the site relied on a custom main.css rule to cap it. Without
       that rule it stretches into an oversized box and pushes the account/cart
       icons onto a second row. Capping it here also keeps the native input and
       the Algolia bar the same size, so the swap on load is seamless.
       (Belongs in the theme CSS ideally, but kept here so it travels with the
       Algolia styling.)
       --------------------------------------------------------------------- */
    .header__search {
      max-width: 520px !important;
      margin-left: auto !important;
      margin-right: auto !important;
    }

    /* ---------------------------------------------------------------------
       Make the Algolia search bar (.aa-Form) look identical to the theme's
       native search input, so there's no visible flash when Algolia replaces
       the native input on load. The native .search__input has no border, the
       theme's input radius, and the --search-bg-color background — we reuse the
       exact same variables so it stays in sync with the theme.
       --------------------------------------------------------------------- */
    .aa-Form {
      background-color: var(--search-bg-color, rgba(var(--text-color) / 0.08)) !important;
      border: 0 !important;
      border-radius: var(--input-lg-border-radius, var(--input-border-radius, 11px)) !important;
      box-shadow: none !important;
    }
    .header__search .aa-InputWrapper {
      position:relative;
      }
    .header__search .aa-InputWrapper::after {
      content:'What do You need to ride?'
      display:block;
      postion:absolute;
      top:50%;
      left:50%;
      transform: translate(-50%,-50%);
    }
    .aa-Input {
      background-color: transparent !important;
    }
    button.aa-SubmitButton {
        display: flex;
        align-items: center;
    }
    /* The Algolia search form ships with min-width:650px, which overflows the
       capped .header__search container — make the whole search subtree fill the
       container instead so the bar isn't too wide. */
    .header__search form.search,
    .header__search predictive-search,
    .header__search .aa-Autocomplete,
    .header__search .aa-Form {
      width: 100% !important;
      min-width: 0 !important;
      max-width: 100% !important;
    }
    /* Move the search icon to the RIGHT to match the native search input
       (Algolia puts it on the left). aa-Form is a flexbox: reorder so the input
       is first, then the clear button, then the search icon on the far right. */
    .header__search .aa-InputWrapper {
      order: 1 !important;
    }
    .header__search .aa-InputWrapperSuffix {
      order: 2 !important;
    }
    .header__search .aa-InputWrapperPrefix {
      order: 3 !important;
    }
    .header__search .aa-Input {
      padding-left: 16px !important;
    }
    /* Hide placeholder text in the header search input. */
    .header__search .aa-Input::placeholder {
      color: transparent !important;
      opacity: 0 !important;
    }

    /* ---------------------------------------------------------------------
       Mobile header search bar: the outer form.search / aa-MainContainer
       carries a theme border and slight radius that survives our aa-Form
       rules. On mobile we want a pill-shaped borderless bar, matching the
       rounded detached overlay style.
       --------------------------------------------------------------------- */
    @media (max-width: 767px) {
      .header__search form.search,
      .header__search .aa-MainContainer {
        border: 0 !important;
        box-shadow: none !important;
        background: transparent !important;
      }
      .header__search .aa-Form {
        border-radius: 999px !important;
      }
    }

    /* ---------------------------------------------------------------------
       Header autocomplete dropdown (.aa-Panel): center it under the search
       bar (it was left-aligned and overhung only to the right) and match the
       search bar — borderless with the theme's 11px input radius — so it reads
       as an integrated extension of the bar. A soft shadow keeps the floating
       panel separated from the page since it no longer has a border.
       The panel only opens on typing. Scoped to >=768px; on mobile Algolia
       uses a separate detached overlay.
       --------------------------------------------------------------------- */
    @media (min-width: 768px) {
      .aa-Panel {
        left: 50% !important;
        right: auto !important;
        transform: translateX(-50%);
        margin-top: 8px;
        max-width: calc(100vw - 32px);
        border: 0 !important;
        border-radius: var(--input-lg-border-radius, var(--input-border-radius, 11px)) !important;
        box-shadow: 0 12px 32px rgba(0, 0, 0, 0.16) !important;
        overflow: hidden;
      }
    }
    /* No uppercase anywhere in the dropdown. */
    .aa-Panel, .aa-Panel * {
      text-transform: none !important;
    }
    /* Remove the divider lines next to the section headings. */
    .aa-Panel .aa-SourceHeaderLine {
      display: none !important;
    }
    /* Bigger product images. */
    .aa-Panel .aa-PanelSection--right .aa-ItemPicture {
      height: auto;
    }
    .aa-Panel .aa-PanelSection--right .aa-ItemPicture img {
      width: 100%;
      height: 185px;
      object-fit: contain;
      /* Blend the image's white photo background into the item background so
         the grey hover state doesn't leave an ugly white box around the image. */
      mix-blend-mode: multiply;
    }
    /* Even, roomier padding so the section headings aren't cramped against the
       panel's rounded corner (top spacing was ~16px while left was ~8px). */
    .aa-Panel .aa-PanelLayout {
      padding: 20px;
    }
    .aa-Panel .aa-SourceHeader {
      margin: 0 0 12px 0;
    }
    .aa-Panel .aa-SourceHeader .aa-SourceHeader {
      margin: 0;
    }
    /* Brand line: just the vendor, muted (default was an off-brand purple
       link colour inherited from the item link). */
    .aa-Panel .aa-ItemContentBrand {
      color: #767676 !important;
      font-size: 12px !important;
      font-weight: 600 !important;
    }
    .aa-Panel .aa-ProductItem .aa-ItemContentTitle {
      color: #000 !important;
    }
    /* Price: red current price when on sale, muted struck-through original. */
    .aa-Panel .aa-ItemContentPrice {
      display: flex;
      align-items: baseline;
      gap: 8px;
    }
    .aa-Panel .aa-ItemContentPrice.aa-price--on-sale .aa-ItemContentPriceCurrent {
      color: #e32b2b;
      font-weight: 700;
    }
    .aa-Panel .aa-ItemContentPriceCompare {
      color: #767676;
      font-size: 12px;
    }
    /* Slimmer, subtler scrollbar on the right of the panel. */
    .aa-Panel .aa-Panel--scrollable,
    .aa-Panel .aa-PanelLayout {
      scrollbar-width: thin;
      scrollbar-color: #cfcfcf transparent;
    }
    .aa-Panel .aa-Panel--scrollable::-webkit-scrollbar,
    .aa-Panel .aa-PanelLayout::-webkit-scrollbar {
      width: 8px;
    }
    .aa-Panel .aa-Panel--scrollable::-webkit-scrollbar-thumb,
    .aa-Panel .aa-PanelLayout::-webkit-scrollbar-thumb {
      background: #cfcfcf;
      border-radius: 8px;
      border: 2px solid #fff;
    }
    .aa-Panel .aa-Panel--scrollable::-webkit-scrollbar-track,
    .aa-Panel .aa-PanelLayout::-webkit-scrollbar-track {
      background: transparent;
    }

    /* ---------------------------------------------------------------------
       Mobile (<768px): the autocomplete panel is the same inline two-column
       mega-panel as desktop, which is ~830px wide and overflows a phone.
       Make it span the full viewport with NO border, stack the Collections /
       Products sections, and show the products 2 per row fitting the screen.
       The grid uses minmax(0,1fr) + min-width:0 on the items so the columns
       actually shrink to fit (plain 1fr keeps a min-content size and overflows,
       which is why it was still cut off).
       --------------------------------------------------------------------- */
    @media (max-width: 767px) {
      .aa-Panel {
        left: 0 !important;
        right: 0 !important;
        width: 100vw !important;
        max-width: 100vw !important;
        transform: none !important;
        border: none !important;
        border-radius: 0 !important;
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12) !important;
        box-sizing: border-box !important;
        overflow-x: hidden !important;
      }
      .aa-Panel .aa-PanelLayout {
        padding: 12px !important;
        box-sizing: border-box !important;
        max-width: 100vw !important;
      }
      .aa-Panel .aa-PanelSections {
        flex-direction: column !important;
        gap: 8px !important;
        max-width: 100% !important;
      }
      .aa-Panel .aa-PanelSection--left,
      .aa-Panel .aa-PanelSection--right {
        width: 100% !important;
        max-width: 100% !important;
      }
      .aa-Panel .aa-PanelSection--right .aa-List {
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
        gap: 8px !important;
      }
      .aa-Panel .aa-PanelSection--right .aa-Item,
      .aa-Panel .aa-PanelSection--right .aa-ProductItem {
        min-width: 0 !important;
        max-width: 100% !important;
      }
      .aa-Panel .aa-PanelSection--right .aa-ItemPicture img {
        height: 110px !important;
      }
      .aa-Panel .aa-SourceHeader {
        margin: 0 0 8px 0 !important;
      }
    }

    /* ---------------------------------------------------------------------
       Below 680px Algolia replaces the header input with a fake trigger
       button (.aa-DetachedSearchButton) and opens a full-screen overlay
       (.aa-DetachedContainer) when tapped. Style both to match our design.
       These classes only exist in detached mode so no media query needed.
       --------------------------------------------------------------------- */

    /* --- Trigger button shown in the header at < 680px --- */
    .aa-DetachedSearchButton {
      width: 100% !important;
      display: flex !important;
      align-items: center !important;
      flex-direction: row-reverse !important; /* icon on the RIGHT */
      background-color: var(--search-bg-color, rgba(0, 0, 0, 0.08)) !important;
      border: 0 !important;
      border-radius: 999px !important;
      box-shadow: none !important;
      padding: 0 16px 0 12px !important;
      height: 44px !important;
      cursor: text !important;
    }
    .aa-DetachedSearchButtonIcon {
      display: flex !important;
      align-items: center !important;
      flex-shrink: 0 !important;
      margin-left: 8px !important;
    }
    .aa-DetachedSearchButtonPlaceholder {
      display: none !important; /* hide "Search" placeholder text */
    }
    .aa-DetachedSearchButtonQuery {
      flex: 1 !important;
      text-align: left !important;
      color: #000 !important;
      font-size: 1rem !important;
      white-space: nowrap !important;
      overflow: hidden !important;
      text-overflow: ellipsis !important;
    }

    /* --- Overlay search form (opened when button is tapped) --- */
    /* Pill-shaped input bar */
    .aa-DetachedContainer .aa-Form,
    .aa-DetachedFormContainer .aa-Form {
      border-radius: 999px !important;
      background-color: var(--search-bg-color, rgba(0, 0, 0, 0.08)) !important;
      border: 0 !important;
      box-shadow: none !important;
    }
    /* Icon to the RIGHT */
    .aa-DetachedContainer .aa-InputWrapper,
    .aa-DetachedFormContainer .aa-InputWrapper {
      order: 1 !important;
    }
    .aa-DetachedContainer .aa-InputWrapperSuffix,
    .aa-DetachedFormContainer .aa-InputWrapperSuffix {
      order: 2 !important;
    }
    .aa-DetachedContainer .aa-InputWrapperPrefix,
    .aa-DetachedFormContainer .aa-InputWrapperPrefix {
      order: 3 !important;
    }
    .aa-DetachedContainer .aa-Input,
    .aa-DetachedFormContainer .aa-Input {
      padding-left: 16px !important;
    }
    .aa-DetachedContainer .aa-Input::placeholder,
    .aa-DetachedFormContainer .aa-Input::placeholder {
      color: rgba(0, 0, 0, 0.5) !important;
      opacity: 1 !important;
    }

    /* ---------------------------------------------------------------------
       Mobile: replace the "Cancel" text button with a ✕ icon, and hide
       the clear (×) button that appears inside the input while typing.
       --------------------------------------------------------------------- */
    /* Hide the X/clear button inside the search input */
    .aa-ClearButton {
      display: none !important;
    }
    /* Replace "Cancel" text with a ✕ cross on mobile */
    .aa-DetachedCancelButton {
      font-size: 0 !important;
      color: transparent !important;
      padding: 8px !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }
    .aa-DetachedCancelButton::before {
      content: "✕";
      font-size: 18px;
      color: #000;
      line-height: 1;
    }
  `;
  (document.head || document.documentElement).appendChild(style);
})();

// ---------------------------------------------------------------------------
// Translate all Algolia UI strings to German by overriding the translations
// object that the Shopify app uses for every rendered widget and template.
//
// This MUST run before Algolia constructs its widgets (sort dropdown, facet
// headers, results-count text, etc.) — those widgets read translations.* once
// at construction time and bake the strings into the DOM; they don't re-read
// the object later. Doing this only inside "algolia.hooks.initialize" was too
// late: that event fires after (or alongside) widget construction, so the
// object got patched correctly (verified via window.algoliaShopify.config),
// but the already-rendered chrome never picked up the new values.
//
// Calling this immediately at top level — before the event — patches the
// object while it's still empty/default, ahead of widget construction. We
// also keep calling it inside the event listener below as a safety net, in
// case Algolia ever replaces window.algoliaShopify.translations with a fresh
// object after our top-level call runs.
// ---------------------------------------------------------------------------
function applyGermanAlgoliaTranslations() {
  try {
    const t = window.algoliaShopify && window.algoliaShopify.translations;
    if (t) {
      t.addToCart        = "In den Warenkorb";
      t.allProducts      = "Alle Produkte anzeigen";
      t.articles         = "Artikel";
      t.by               = "von";
      t.changeInput      = "Suche anpassen";
      t.clearAll         = "Alle löschen";
      t.clearFilters     = "Filter löschen";
      t.collections      = "Kollektionen";
      t.in               = "in";
      t.matching         = "passend zu";
      t.noResultFor      = "Keine Ergebnisse für";
      t.noResultFound    = "Kein Ergebnis gefunden";
      t.oneResultFound   = "1 Ergebnis gefunden";
      t.or               = "oder";
      t.outOf            = "von";
      t.outOfStock       = "Ausverkauft";
      t.pages            = "Seiten";
      t.products         = "Produkte";
      t.relevance        = "Relevanz";
      t.resultsFound     = "Ergebnisse gefunden";
      t.search           = "Aktuelle Suche";
      t.searchForProduct = "Produkte suchen";
      t.searchTitle      = "Suchergebnis";
      t.selectedFilter   = "Ausgewählte Filter";
      t.showLess         = "Weniger anzeigen";
      t.showMore         = "Mehr anzeigen";
      t.showFilters      = "Filter anzeigen";
      t.sortBy           = "Sortiert nach";
      t.suggestions      = "Vorschläge";
      t.taxFree          = "Steuerfrei";
      t.try              = "Versuche";

      // Facet (filter sidebar) headers — e.g. "Price", "Vendor", "Type", "Tags".
      // These live in their own array (one entry per configured facet), keyed
      // by the facet's underlying attribute name, not flat t.* keys.
      const facetTitles = {
        price:        "Preis",
        price_range:  "Preisbereich",
        vendor:       "Marke",
        product_type: "Kategorie",
        tags:         "Tags",
      };
      if (Array.isArray(t.facets)) {
        t.facets.forEach((facet) => {
          if (facet && facetTitles[facet.name]) {
            facet.title = facetTitles[facet.name];
          }
        });
      }

      return true;
    }
  } catch (e) {}
  return false;
}

// Apply as early as possible (top level, before any widget builds).
if (!applyGermanAlgoliaTranslations()) {
  // window.algoliaShopify.translations isn't there yet — keep retrying on
  // every animation frame until it appears, instead of waiting for the
  // (too-late) "algolia.hooks.initialize" event. Capped so a permanently
  // missing object doesn't poll forever.
  let attempts = 0;
  (function pollForTranslations() {
    if (applyGermanAlgoliaTranslations() || ++attempts > 200) return;
    requestAnimationFrame(pollForTranslations);
  })();
}

document.addEventListener("algolia.hooks.initialize", () => {

  // ---------------------------------------------------------------------------
  // Make the autocomplete work on localized storefronts (other languages /
  // markets). The app's input_selector is the exact match `form[action="/search"]`,
  // but on localized URLs Shopify prefixes the form action with the locale
  // (e.g. `/en-no/search`, `/de/search`), so the selector never matches and the
  // autocomplete popup never attaches. Switch to an ends-with selector that
  // matches the search form on every locale (including the default `/search`).
  // This runs before the autocomplete is built, so it takes effect.
  // ---------------------------------------------------------------------------
  try {
    const cfg = window.algoliaShopify && window.algoliaShopify.config;
    if (cfg && typeof cfg.input_selector === "string" && cfg.input_selector === 'form[action="/search"]') {
      cfg.input_selector = 'form[action$="/search"]';
    }
  } catch (e) {}

  // Safety net — see comment on applyGermanAlgoliaTranslations above.
  applyGermanAlgoliaTranslations();

  // ---------------------------------------------------------------------------
  // Restore the theme's search placeholder. Algolia leaves the autocomplete
  // input blank, but the native input has e.g. "What do you need to ride?".
  // We capture the native placeholder NOW (this runs before Algolia replaces
  // the native input, so it's still in the DOM — and this keeps it correct per
  // locale/translation), then apply it to the Algolia input once it mounts.
  // ---------------------------------------------------------------------------


  // ---------------------------------------------------------------------------
  // Use Algolia's built-in price helpers — they know the exact indexed fields
  // and handle multi-market / multi-currency automatically
  // ---------------------------------------------------------------------------
  // NOTE: read the helpers lazily at call time, NOT once here.
  // At "algolia.hooks.initialize" time window.algoliaShopify.helpers is not
  // populated yet, so capturing it eagerly stores `undefined`. The template
  // would then throw "Cannot read properties of undefined (reading
  // 'displayPrice')" on every hit, and Algolia silently falls back to its
  // default template (which is why the custom card never appeared).
  function getHelpers() {
    return (window.algoliaShopify && window.algoliaShopify.helpers) || null;
  }

  function getPrice(hit) {
    const helpers = getHelpers();
    return (helpers && helpers.displayPrice(hit)) || "";
  }

  // This store's Algolia index returns empty from displayStrikedPrice /
  // displayDiscount for EVERY product, even though each hit has a valid
  // compare_at_price > price. So we prefer the helper when it produces output,
  // but otherwise compute the sale fields straight from the raw hit data.
  function isHitOnSale(hit) {
    return (
      typeof hit.compare_at_price === "number" &&
      typeof hit.price === "number" &&
      hit.compare_at_price > hit.price
    );
  }

  function getStrikedPrice(hit) {
    const helpers = getHelpers();
    if (!helpers) return "";
    const fromHelper = helpers.displayStrikedPrice(hit);
    if (fromHelper) return fromHelper;
    // Reuse displayPrice's currency formatting by swapping in the compare price.
    if (isHitOnSale(hit)) {
      return helpers.displayPrice(
        Object.assign({}, hit, { price: hit.compare_at_price })
      );
    }
    return "";
  }

  function getDiscount(hit) {
    const helpers = getHelpers();
    const fromHelper = helpers && helpers.displayDiscount(hit);
    if (fromHelper) return fromHelper;
    if (isHitOnSale(hit)) {
      return "-" + Math.round((1 - hit.price / hit.compare_at_price) * 100) + "%";
    }
    return "";
  }

  // ---------------------------------------------------------------------------
  // Tag-based badge parser: badge_TEXT_TIPTEXT_TEXTCOLOR_BGCOLOR
  // e.g. badge_NEU__ffffff_e63946
  // ---------------------------------------------------------------------------
  function getBadgeFromTags(tags) {
    if (!Array.isArray(tags)) return null;
    for (const tag of tags) {
      if (tag.startsWith("badge_")) {
        const parts = tag.split("badge_")[1].split("_");
        return {
          text:      parts[0] || "",
          tip:       parts[1] || "",
          textColor: parts[2] ? `#${parts[2]}` : "#ffffff",
          bgColor:   parts[3] ? `#${parts[3]}` : "#000000",
        };
      }
    }
    return null;
  }

  // ---------------------------------------------------------------------------
  // Available sizes from variants (option1), with green/yellow dot state
  // ---------------------------------------------------------------------------
  function getAvailableSizes(variants) {
    if (!Array.isArray(variants) || variants.length === 0) return [];
    const seen = new Set();
    const result = [];
    for (const v of variants) {
      const size = (v.option1 || v.title || "").trim();
      if (!size || seen.has(size) || !v.available) continue;
      seen.add(size);
      const backordered =
        v.inventory_management &&
        v.inventory_policy === "continue" &&
        v.inventory_quantity <= 0;
      result.push({ size, backordered });
    }
    return result;
  }

  // ---------------------------------------------------------------------------
  // Cart API — single-variant quick add
  // ---------------------------------------------------------------------------
  function addToCartAndRefresh(variantId) {
    if (!variantId) return;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then((r) => r.json())
      .then(() => {
        // Trigger cart drawer refresh if theme supports it
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:open"));
        if (!document.querySelector("[data-cart-drawer], cart-drawer")) {
          window.location.href = "/cart";
        }
      })
      .catch(console.error);
  }

  // ---------------------------------------------------------------------------
  // Config
  // IMAGE_RATIO: adjust to match settings.prod_card_image_ratio
  //   1 = square, 1.333 = 4:3 portrait, 1.5 = 2:3, 0.75 = landscape
  // ---------------------------------------------------------------------------
  const IMAGE_RATIO = 1.333;
  const IMAGE_PADDING = `${((1 / IMAGE_RATIO) * 100).toFixed(2)}%`;

  const pageLocale = document.documentElement.lang || "de";
  const moreSizesLabel = pageLocale.startsWith("de") ? "mehr" : "more";
  const addToCartLabel = pageLocale.startsWith("de") ? "In den Warenkorb" : "Add to cart";
  const chooseOptionsLabel = pageLocale.startsWith("de") ? "Optionen wählen" : "Choose options";
  const viewDetailsLabel = pageLocale.startsWith("de") ? "Details ansehen" : "View details";

  const SIZE_PILL_LIMIT = 2;

  // ---------------------------------------------------------------------------
  // Product card template hook
  // ---------------------------------------------------------------------------
  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchProductTemplate",
    (_defaultTemplate, hit, html, components, trackSearchAttribution) => {

      const productUrl = hit.url || `/products/${hit.handle}`;
      const isAvailable = hit.available !== false;

      // Use Algolia helpers for price — covers multi-currency / markets
      const priceDisplay     = getPrice(hit);
      const strikedPrice     = getStrikedPrice(hit);
      const discountDisplay  = getDiscount(hit);
      const isOnSale         = !!strikedPrice;

      const badge = getBadgeFromTags(hit.tags);

      // Variants & sizes
      const variants = hit.variants || [];
      const availableSizes = getAvailableSizes(variants);
      // "Default Title" is Shopify's sentinel for single-variant products
      const hasOnlyDefaultVariant =
        variants.length === 0 ||
        (variants.length === 1 && (variants[0].title === "Default Title" || variants[0].option1 === "Default Title")) ||
        (Array.isArray(hit.options) && hit.options.length === 1 && hit.options[0] === "Title");

      // Size truncation — mirrors Liquid logic
      const totalSizeChars = availableSizes.reduce((n, v) => n + v.size.length, 0);
      const truncateSizes  = availableSizes.length > 3 || totalSizeChars > 8;
      const visibleSizes   = truncateSizes ? availableSizes.slice(0, SIZE_PILL_LIMIT) : availableSizes;
      const showMoreSizes  = truncateSizes && availableSizes.length > SIZE_PILL_LIMIT;

      // First variant ID for single-variant add-to-cart
      const firstVariantId = variants[0]?.id;

      return html`
        <product-card class="card card--product h-full card--no-lines relative flex">

          <!-- ── Image ──────────────────────────────────────────────────── -->
          <div class="card__media relative">
            <a
              href="${productUrl}"
              aria-label="${hit.title}"
              class="media block relative js-prod-link"
              style="padding-top: ${IMAGE_PADDING};"
              tabindex="-1"
              onClick="${() => trackSearchAttribution(hit)}"
            >
              ${hit.image
                ? html`<img
                    src="${hit.image}"
                    alt="${hit.title}"
                    class="img-fit img-fit--contain card__main-image"
                    loading="lazy"
                    width="460"
                  />`
                : html`<div class="media__placeholder img-fit"></div>`}
            </a>

            <!-- Discount badge (-47% style) -->
            ${isOnSale && discountDisplay
              ? html`<div class="product-label product-label--sale absolute">
                  <span>${discountDisplay}</span>
                </div>`
              : ""}

            <!-- Sold out badge -->
            ${!isAvailable
              ? html`<div class="product-label product-label--sold-out absolute">
                  <span>Ausverkauft</span>
                </div>`
              : ""}

            <!-- Tag-based custom badge (badge_TEXT_TIP_TEXTCOLOR_BGCOLOR) -->
            ${badge
              ? html`<div
                  class="product-label-container absolute top-0 start"
                  style="${isOnSale ? "margin-top:43px;" : ""}"
                >
                  <div class="tip_badge-container">
                    <div class="badge-container" style="background: ${badge.bgColor};">
                      <span style="color: ${badge.textColor};" class="badge-main">${badge.text}</span>
                      ${badge.tip
                        ? html`<span style="color: ${badge.textColor};" class="badge-tip">${badge.tip}</span>`
                        : ""}
                    </div>
                  </div>
                </div>`
              : ""}
          </div>

          <!-- ── Info ───────────────────────────────────────────────────── -->
          <div class="card__info-container flex flex-col flex-auto relative">
            <div class="card__info w-full">
              <div class="card__info-inner inline-block w-full">

                <!-- Vendor -->
                ${hit.vendor
                  ? html`<p class="card__vendor font-bold mb-0">${hit.vendor}</p>`
                  : ""}

                <!-- Title with search-term highlighting -->
                <p class="card__title mt-1 mb-0">
                  <a
                    href="${productUrl}"
                    class="card-link text-current js-prod-link"
                    onClick="${() => trackSearchAttribution(hit)}"
                  >
                    ${components.Highlight({ attribute: "title", hit })}
                  </a>
                </p>

                <!-- Price — uses Algolia helpers for correct field names & formatting -->
                <!-- price--on-sale drives the theme's red sale-price color -->
                <div class="price price--top ${isOnSale ? "price--on-sale" : ""}">
                  ${isOnSale
                    ? html`<dl class="price__list">
                        <dt class="visually-hidden">Vergleichspreis</dt>
                        <dd><s class="price__compare theme-money">${strikedPrice}</s></dd>
                        <dt class="visually-hidden">Angebotspreis</dt>
                        <dd><span class="price__current price__current--sale theme-money">${priceDisplay}</span></dd>
                      </dl>`
                    : html`<dl class="price__list">
                        <dt class="visually-hidden">Preis</dt>
                        <dd><span class="price__current theme-money">${priceDisplay}</span></dd>
                      </dl>`}
                </div>

                <!-- Available sizes with green / yellow availability dots -->
                ${!hasOnlyDefaultVariant && availableSizes.length > 0
                  ? html`<div
                      class="product-card-sizes text-xs mt-1"
                      style="display:flex;gap:6px;overflow-x:auto;flex-wrap:nowrap;-webkit-overflow-scrolling:touch;"
                    >
                      ${visibleSizes.map((v) =>
                        html`<span class="product-card-size-box" key="${v.size}">
                          ${v.size}
                          <span class="${v.backordered ? "yellow-dot" : "green-dot"}"></span>
                        </span>`
                      )}
                      ${showMoreSizes
                        ? html`<span class="sizes-more">${moreSizesLabel}</span>`
                        : ""}
                    </div>`
                  : ""}

              </div>
            </div>

            <!-- ── Quick Add ───────────────────────────────────────────── -->
            <div class="card__quick-add">
              ${hasOnlyDefaultVariant && isAvailable
                ? html`<button
                    type="button"
                    class="btn btn--primary w-full"
                    onClick="${(e) => { e.preventDefault(); addToCartAndRefresh(firstVariantId); }}"
                  >
                    <span class="quick-add-btn-text block pointer-events-none">${addToCartLabel}</span>
                  </button>`
                : html`<button
                    type="button"
                    class="btn btn--primary w-full js-quick-add"
                    aria-haspopup="dialog"
                    data-product-url="${productUrl}"
                    data-product-default-variant="false"
                  >
                    <span class="quick-add-btn-text block pointer-events-none">${chooseOptionsLabel}</span>
                  </button>`}

              <a
                href="${productUrl}"
                class="btn btn--secondary quick-add-view-btn"
                onClick="${() => trackSearchAttribution(hit)}"
              >
                ${viewDetailsLabel}
              </a>
            </div>
          </div>

        </product-card>
      `;
    }
  );

  // ---------------------------------------------------------------------------
  // Header autocomplete dropdown — product item template
  // Defaults render "<product_type> by <vendor>" and only the current price.
  // We render just the vendor (no category), keep the title, and add the
  // struck-through original price (reusing the same sale helpers as above).
  // Signature: (defaultTemplate, { item, html, components }, ...)
  // ---------------------------------------------------------------------------
  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    (_defaultTemplate, { item, html, components }) => {
      const priceDisplay = getPrice(item);
      const strikedPrice = getStrikedPrice(item);
      const isOnSale     = !!strikedPrice;
      const image        = item.image || item.product_image || "";
      const productUrl   = item.url || `/products/${item.handle}`;

      return html`
        <a class="aa-ItemLink aa-ProductItem" href="${productUrl}">
          <div class="aa-ItemContent">
            <div class="aa-ItemPicture aa-ItemPicture--loaded">
              <img src="${image}" alt="${item.title}" />
            </div>
            <div class="aa-ItemContentBody">
              <div class="aa-ItemContentBrand">${item.vendor || ""}</div>
              <div class="aa-ItemContentTitleWrapper">
                <div class="aa-ItemContentTitle">
                  ${components.Highlight({ hit: item, attribute: "title" })}
                </div>
              </div>
              <div class="aa-ItemContentPrice ${isOnSale ? "aa-price--on-sale" : ""}">
                <span class="aa-ItemContentPriceCurrent">${priceDisplay}</span>
                ${isOnSale
                  ? html`<s class="aa-ItemContentPriceCompare">${strikedPrice}</s>`
                  : ""}
              </div>
            </div>
          </div>
        </a>
      `;
    }
  );
});
